export const DOCUMENT_SCORING_KNOCKOUT_CRITERIA_UPDATED =
  "Charisma.Leasing.PublishedLanguage.Events.LeasingDocument.Scoring.DocumentScoringKnockoutCriteriaUpdated";
export const DOCUMENT_SCORING_CATEGORY_UPDATED =
  "Charisma.Leasing.PublishedLanguage.Events.LeasingDocument.Scoring.DocumentScoringCategoryUpdated";
export const DOCUMENT_SCORING_INVALIDATED =
  "Charisma.Leasing.PublishedLanguage.Events.LeasingDocument.Scoring.DocumentScoringInvalidated";
export const DOCUMENT_SCORING_FINANCIAL_INDICATORS_UPDATED =
  "Charisma.Leasing.PublishedLanguage.Events.LeasingDocument.Scoring.DocumentScoringFinancialIndicatorsUpdated";
export const DOCUMENT_FINANCIAL_INDICATOR_DIMENSIONS_UPDATED =
  "Charisma.Leasing.PublishedLanguage.Events.LeasingDocument.Scoring.FinancialIndicatorDimensionsUpdated";
